(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.service('vvTakenQuizIds', function (vvLocalStorage) {
    var takenQuizIds = {};
    var takenQuizIdLoaded = false;
    var recentQuizIds = [];

    var loadTakenQuizIds = function() {
      if (!takenQuizIdLoaded) {
        takenQuizIds = vvLocalStorage.get('takenQuizIds') || {};
        recentQuizIds = vvLocalStorage.get('recentQuizIds') || [];
        takenQuizIdLoaded = true;
      }
    };

    this.getTakenQuizIds = function() {
      loadTakenQuizIds();
      return takenQuizIds;
    };

    this.setQuizTaken = function(id, taken) {
      loadTakenQuizIds();
      takenQuizIds[id] = taken;
      if (taken) {
        vvLocalStorage.set('takenQuizIds', takenQuizIds);
        if (recentQuizIds.indexOf(id) < 0) {
          recentQuizIds.push(id);
          if (recentQuizIds.length > 20) {
            recentQuizIds.splice(0, recentQuizIds.length - 20);
          }
          vvLocalStorage.set('recentQuizIds', recentQuizIds);
        }
      }
    };

    this.isQuizTaken = function(id) {
      loadTakenQuizIds();
      return takenQuizIds[id];
    };

    this.getRecentIds = function() {
      loadTakenQuizIds();
      return angular.copy(recentQuizIds);
    };
  });
})(window, window.angular);
